"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TriggerContainer = exports.Anchor = exports.Label = exports.IconCart = void 0;
const Cart_1 = require("@kawaui/icons/build/icons/action/Cart");
const styled_components_1 = __importStar(require("styled-components"));
exports.IconCart = (0, styled_components_1.default)(Cart_1.IconCart) `
  @media (min-width: ${({ theme }) => theme.breakpoint.tablet}) {
    path {
      fill: ${({ theme }) => theme.colors.main.base};
    }
  }
`;
exports.Label = styled_components_1.default.div `
  display: none;
  margin-left: 4px;

  color: ${({ theme }) => theme.colors.main.base};

  font-family: ${({ theme }) => theme.fontFamily.title};
  white-space: nowrap;

  @media (min-width: ${({ theme }) => theme.breakpoint.tablet}) {
    display: initial;
  }
`;
const transparentStyle = (0, styled_components_1.css) `
  color: ${({ open, theme }) => (open ? theme.colors.gray.s700 : theme.colors.white.s100)};

  ${exports.IconCart} {
    path {
      fill: ${({ open, theme }) => (open ? theme.colors.main.base : 'currentColor')};
    }
  }

  ${exports.Label} {
    color: ${({ open, theme }) => (open ? theme.colors.main.base : theme.colors.white.s100)};
  }
`;
const transparentDesktopStyle = (0, styled_components_1.css) `
  ${({ open, theme }) => !open &&
    (0, styled_components_1.css) `
      border-color: ${theme.colors.white.s100};
    `};
`;
exports.Anchor = styled_components_1.default.a `
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
`;
exports.TriggerContainer = styled_components_1.default.div `
  position: relative;

  display: inline-flex;
  flex-direction: column;
  align-items: center;

  font-family: ${({ theme }) => theme.fontFamily.text};

  border-radius: ${({ theme }) => theme.radius.s100};
  cursor: pointer;

  ${({ isTransparent }) => isTransparent && transparentStyle}

  user-select: none;

  @media (min-width: ${({ theme }) => theme.breakpoint.tablet}) {
    flex-direction: row;
    box-sizing: border-box;
    height: 36px;
    padding: 0 6px;
    border: 1px solid ${({ theme }) => theme.colors.main.base};

    ${({ isTransparent }) => isTransparent && transparentDesktopStyle};
  }
`;
